/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Replaceconfirm3Inputs */

const en_settings_reportingapikeys_generate_replaceconfirm3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Replaceconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace key`)
};

/**
* | output |
* | --- |
* | "Replace key" |
*
* @param {Settings_Reportingapikeys_Generate_Replaceconfirm3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_replaceconfirm3 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Replaceconfirm3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Replaceconfirm3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_replaceconfirm3(inputs)
});
export { settings_reportingapikeys_generate_replaceconfirm3 as "settings_reportingApiKeys_generate_replaceConfirm" }